import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { 
  LayoutDashboard, Globe, Users, Image, FileText, LogOut, Home, ShoppingBag, Package, Film, MessageSquare, Mail, Clapperboard, UserCog
} from "lucide-react";
import FanVerseLogo from "@/components/FanVerseLogo";

const AdminLayout = ({ children, title }) => {
  const { logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: "/admin", label: "Dashboard", icon: LayoutDashboard },
    { path: "/admin/universes", label: "Universes", icon: Globe },
    { path: "/admin/characters", label: "Characters", icon: Users },
    { path: "/admin/gallery", label: "Gallery Uploads", icon: Image },
    { path: "/admin/media", label: "Media Gallery", icon: Film },
    { path: "/admin/content", label: "AI Content", icon: FileText },
    { path: "/admin/filmography", label: "Filmography", icon: Clapperboard },
    { path: "/admin/products", label: "Products", icon: ShoppingBag },
    { path: "/admin/orders", label: "Orders", icon: Package },
    { path: "/admin/contributions", label: "Contributions", icon: MessageSquare },
    { path: "/admin/users", label: "Users", icon: UserCog },
    { path: "/admin/newsletter", label: "Newsletter", icon: Mail },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen flex bg-[#030712]">
      {/* Sidebar */}
      <aside className="fixed left-0 top-0 bottom-0 w-64 admin-sidebar flex flex-col z-40">
        {/* Logo */}
        <div className="p-6 border-b border-white/5">
          <Link to="/admin" className="inline-block">
            <FanVerseLogo size={32} light />
          </Link>
          <span className="text-xs font-mono text-slate-500 mt-1 block">ADMIN PANEL</span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 overflow-y-auto">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item flex items-center gap-3 px-6 py-3 ${
                isActive(item.path) ? "active" : ""
              }`}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Footer Actions */}
        <div className="p-4 border-t border-white/5 space-y-2">
          <Link
            to="/"
            className="admin-nav-item flex items-center gap-3 px-4 py-2 w-full"
          >
            <Home className="w-5 h-5" />
            View Site
          </Link>
          <button
            onClick={logout}
            className="admin-nav-item flex items-center gap-3 px-4 py-2 w-full text-left hover:text-red-500"
            data-testid="admin-logout"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64">
        {/* Header */}
        <header className="sticky top-0 z-30 bg-[#0B0F19]/80 backdrop-blur-xl border-b border-white/5 px-8 py-4">
          <h1 className="text-xl font-bold text-white font-['Outfit']">{title}</h1>
        </header>

        {/* Content */}
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
